module.exports = require("react-konva");